<template>
  <v-menu
    v-model="menu"
    bottom
    right
    offset-y
    max-height="400"
    z-index="9999"
  >
    <template v-slot:activator="{ on, attrs }">
      <div class="d-flex align-center">
        <v-btn
          v-bind="attrs"
          v-on="on"
          icon
          class="mx-6"
          :color="value === 'all' ? 'grey darken-1' : 'primary'"
        >
          <v-icon>mdi-filter-outline</v-icon>
           فیلتر نوع کیوآر
        </v-btn>

        <v-chip
          v-if="value !== 'all'"
          close
          color="primary"
          outlined
          class="rounded-lg mr-2"
          @click:close="clearFilter"
        >
          <v-icon left small v-if="selectedItem">
            mdi-{{ selectedItem.icon }}
          </v-icon>
          {{ selectedItem ? selectedItem.name : 'فیلتر شده' }}
        </v-chip>
      </div>
    </template>

    <!-- لیست انواع کیوآر کد -->
    <v-list dense>
      <!-- گزینه همه موارد -->
      <v-list-item
        @click="selectType('all')"
        :class="{ 'primary--text': value === 'all' }"
      >
        <v-list-item-icon class="mr-3 ml-0">
          <v-icon :color="value === 'all' ? 'primary' : 'grey'">mdi-apps</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>همه موارد</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list-item
        v-for="item in qrTypesList"
        :key="item.value"
        @click="selectType(item.value)"
        :class="{ 'primary--text': value === item.value }"
      >
        <v-list-item-icon class="mr-3 ml-0">
          <v-icon :color="value === item.value ? 'primary' : 'grey'">
            mdi-{{ item.icon }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ item.name }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>

export default {
  name: "QrTypeFilter",
  props: {
    value: {
      type: [String, Number],
      default: "all",
    },
  },
  data() {
    return {
      menu: false,
    };
  },
  computed: {
    qrTypesList() {
      if (typeof this.getQrTypes === 'function') {
        return this.getQrTypes();
      }
      return []; 
    },
    selectedItem() {
      if (this.value === "all") return null;
      return this.qrTypesList.find((item) => item.value === this.value);
    },
  },
  methods: {
    selectType(selectedVal) {
      this.$emit("input", selectedVal);
      this.menu = false; 
    },
    clearFilter() {
      this.$emit("input", "all");
      this.menu = false;
    },
  },
};
</script>
